import React, { useEffect, useState } from "react";
import Icon from "./Icon";
import InstallInstructions, { clearInstallDismiss } from "./InstallInstructions";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

export default function InstallSection() {
  const { t: tr } = useI18n();
  const [deferred, setDeferred] = useState(null);
  const [open, setOpen] = useState(false);

  const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const ua = window.navigator.userAgent || "";
  const isIOS = /iphone|ipad|ipod/i.test(ua);
  const isAndroid = /android/i.test(ua);

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  const nativeInstall = async () => {
    if (!deferred) { setOpen(true); return; }
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  const card = { background: C.card, borderRadius: R.md, padding: S.lg, border: `1px solid ${C.border}`, marginBottom: S.md };
  const btn = (bg, fg) => ({ display: "flex", alignItems: "center", justifyContent: "center", gap: S.sm, background: bg, color: fg, fontWeight: 900, borderRadius: R.md, minHeight: 52, width: "100%", marginTop: S.md });

  return (
    <div data-testid="install-section" style={card}>
      <div style={{ display: "flex", alignItems: "center", gap: S.md }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: C.amber, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon name="shield-checkmark" size={24} color={C.black} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ color: C.text, fontSize: 17, fontWeight: 800 }}>{tr("install.appTitle")}</div>
          <div style={{ color: C.muted, fontSize: 13, marginTop: 2 }}>{tr("install.offlineReady")}</div>
        </div>
      </div>

      {isStandalone ? (
        <div data-testid="install-installed-badge" style={{ ...btn("rgba(16,185,129,0.15)", C.green), border: `1px solid ${C.green}`, fontWeight: 800 }}>
          <Icon name="checkmark-circle" size={20} color={C.green} /> {tr("install.installedBadge")}
        </div>
      ) : isAndroid && deferred ? (
        <button data-testid="install-android-btn" className="pressable" onClick={nativeInstall} style={btn(C.amber, C.black)}>
          <Icon name="download" size={20} color={C.black} /> {tr("install.installSafebook")}
        </button>
      ) : (
        <button data-testid="install-guide-btn" className="pressable" onClick={() => { clearInstallDismiss(); setOpen(true); }} style={btn(C.amber, C.black)}>
          <Icon name="information-circle" size={20} color={C.black} /> {isIOS ? tr("install.appGuide") : tr("install.howToInstall")}
        </button>
      )}

      {!isStandalone && (isAndroid && deferred) && (
        <button data-testid="install-guide-secondary" className="pressable" onClick={() => setOpen(true)} style={{ color: C.amber, fontWeight: 700, fontSize: 14, width: "100%", marginTop: S.sm }}>{tr("install.preferManual")}</button>
      )}

      <InstallInstructions open={open} onClose={() => setOpen(false)} deferredInstall={deferred ? nativeInstall : null} />
    </div>
  );
}
